import { ITuple4 } from '@r3f-component-data-structure';

export const convertStringArrayToITuple4 = (string: string) => {
  return string.split(",").map((i) => (parseInt(i.replace('[','').replace(']','')))) as ITuple4
};